// extracted by mini-css-extract-plugin
export default {"div":"Inicio_div__hHrd9","inicio":"Inicio_inicio__2KwS6"};